module.exports = __webpack_public_path__ + "img/selected1-min.1e30cd4e.png";